import { StatusCode, UserRoles } from "common/enums";
import Breadcrumbs from "components/breadcrumbs";
import * as appRoutes from "config/routes.config";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";


import { message } from "antd";
import MainContent from "./components/mainContent";
import TeacherInfos from "./components/profileInfo";
import TeacherEvents from "./components/teacherEvents";
import s from "./style.module.css";

import * as AUTH_SERVICES from "api/services/auth/auth.services";
import { setNewPasswordRequired } from "store/app/appSlice";
import { openProfileDrawer } from "store/auth/authSlice";

interface Props { }

const TeacherActivities = (props: Props) => {

  const auth = useSelector((state) => state.auth);
  const { isAppInMaintenance } = useSelector((state) => state.auth);
  const { userHavingCalendar, userTeachingOrganismClass } = useSelector((state) => state.app);
  const [postsCount, setPostsCount] = useState(auth?.user?.postsNum ? auth?.user?.postsNum : 0);
  const [docsCount, setDocsCount] = useState(auth?.user?.docsNum ? auth?.user?.docsNum : 0);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const handleAddPost = () => {
    setPostsCount(postsCount + 1);
  };

  const handleAddDocs = (numToAdd: any) => {
    setDocsCount(docsCount + numToAdd);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleClose = () => {
    setIsModalVisible(false);
  };
  const [current, setCurrent] = useState<number>(1);

  const checkToken = async (token: string) => {
    if (!token) return;

    try {
      const response = await AUTH_SERVICES.CheckAffiliationToken(token);
      if (response?.statusCode === StatusCode.OK) {
        message.success("Tu as bien été affilié à l’organisme.");
        localStorage.removeItem("affiliateToken");
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
      else {
        message.error(response?.data?.message);
        localStorage.setItem("affiliateToken", "");
        localStorage.removeItem("affiliateToken");
      }
    } catch (error: any) {
      message.error(error?.response?.data?.message);
      localStorage.setItem("affiliateToken", "");
      localStorage.removeItem("affiliateToken");
    }
  };

  useEffect(() => {
    setIsModalVisible(true);
  }, []);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const isTeacher = auth.user?.roles?.includes(UserRoles.TEACHER);
    const isOTP = auth.user?.step === "otp";
    if (isLoggedIn && isTeacher && isOTP) {
      navigate(appRoutes.REGISTER_TEACHER_BY_EMAIL);
    }
  }, [auth.isLoggedIn, navigate, auth.user?.roles]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const searchParams = new URLSearchParams(location.search);
    if (isLoggedIn) {
      if (searchParams !== undefined) {
        const token = searchParams.get('token');
        if (token !== null) {
          checkToken(token);
        }
      }
      else {
        const affiliateToken = localStorage.getItem("affiliateToken");
        if (affiliateToken) {
          if (!auth?.user?.accountManaged) {
            checkToken(affiliateToken);
          }
        }
      }
    }
  }, [auth.isLoggedIn, location.search]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const affiliateToken = localStorage.getItem("affiliateToken");
    if (isLoggedIn && affiliateToken) {
      checkToken(affiliateToken);
    }
  }, [auth.isLoggedIn]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const classCode = localStorage.getItem("classCode");
    if (isLoggedIn && classCode) {
      /// navigate(`/eleve/mes-classes?classCode=${classCode}`);
      navigate(appRoutes?.STUDENT_INVITATIONS);
    }
  }, [auth.isLoggedIn]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const searchParams = new URLSearchParams(location.search);
    if (isLoggedIn) {
      if (searchParams !== undefined) {
        const organismToken = searchParams.get('organisme_token');
        const organismClassCode = searchParams.get('access_code');
        const userType = searchParams.get('userType');
        if (organismToken && organismClassCode && userType) {
          localStorage.setItem("organismToken", organismToken);
          localStorage.setItem("organismClassCode", organismClassCode);
          localStorage.setItem("userType", userType);
          if (userType === "student") {
            /// navigate(`/eleve/mes-classes?organismClassCode=${organismClassCode}`);
            navigate(appRoutes?.STUDENT_INVITATIONS);
          }
          else {
            navigate(`/teacher/rooms`);
          }
        }
      }
      else {
        const organismToken = localStorage.getItem("organismToken");
        const organismClassCode = localStorage.getItem("organismClassCode");
        const userType = localStorage.getItem("userType");
        if (organismToken && organismClassCode && userType) {
          if (userType === "student") {
            /// navigate(`/eleve/mes-classes?organismClassCode=${organismClassCode}`);
            navigate(appRoutes?.STUDENT_INVITATIONS);
          }
          else {
            navigate(`/teacher/rooms`);
          }
        }
      }
    }
  }, [auth.isLoggedIn, location.search]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const organismToken = localStorage.getItem("organismToken");
    const organismClassCode = localStorage.getItem("organismClassCode");
    const userType = localStorage.getItem("userType");
    if (organismToken && organismClassCode && userType) {
      if (userType === "student") {
        /// navigate(`/eleve/mes-classes?organismClassCode=${organismClassCode}`);
        navigate(appRoutes?.STUDENT_INVITATIONS);
      }
      else {
        navigate(`/teacher/rooms`);
      }
    }
  }, [auth.isLoggedIn]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const searchParams = new URLSearchParams(location.search);
    if (isLoggedIn) {
      if (searchParams !== undefined) {
        const collectiveToken = searchParams.get('collective_token');
        const sessionId = searchParams.get('session_id');
        const classeId = searchParams.get('classe_id');
        if (collectiveToken && sessionId && classeId) {
          localStorage.setItem("collectiveToken", collectiveToken);
          localStorage.setItem("sessionId", sessionId);
          localStorage.setItem("classeId", classeId);
          /// navigate(`/eleve/mes-classes?classeId=${classeId}`);
          navigate(appRoutes?.STUDENT_INVITATIONS);
        }
      }
      else {
        const collectiveToken = localStorage.getItem("collectiveToken");
        const sessionId = localStorage.getItem("sessionId");
        const classeId = localStorage.getItem("classeId");
        if (collectiveToken && sessionId && classeId) {
          /// navigate(`/eleve/mes-classes?classeId=${classeId}`);
          navigate(appRoutes?.STUDENT_INVITATIONS);
        }
      }
    }
  }, [auth.isLoggedIn, location.search]);

  //!EFFECTS
  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const isTeacher = auth.user?.roles?.includes(UserRoles.TEACHER);
    const isCompleted = auth.user?.step === "completed";
    if (isLoggedIn) {
      if (isTeacher && !isCompleted) {
        navigate(appRoutes.COMPLETE_PROFILE);
      }
    }
  }, [auth.isLoggedIn, navigate, auth.user?.roles]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const couponCode = localStorage.getItem("couponCode");
    if (isLoggedIn && couponCode !== null) {
      const couponCodeLink = localStorage.getItem("couponCodeLink");
      if (couponCodeLink !== null) {
        navigate(`/${couponCodeLink}`);
      }
    }
  }, [auth.isLoggedIn]);

  useEffect(() => {
    if (isAppInMaintenance) {
      navigate(appRoutes.MAINTENANCE);
    };
  }, [isAppInMaintenance]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const requestingNewPassword = auth?.user?.requireNewPassword;
    if (isLoggedIn && requestingNewPassword) {
      dispatch(openProfileDrawer());
      dispatch(setNewPasswordRequired(true));
    }
    else {
      dispatch(setNewPasswordRequired(false));
    }
  }, [auth]);

  return (
    <React.Fragment>
      {isMobile && auth?.user?.accountManaged !== "" && <div style={{ height: "0px", width: "100%" }}></div>}
      <div style={{ marginTop: isMobile && auth.user?.roles?.includes(UserRoles.TEACHER) ? (!userHavingCalendar || userTeachingOrganismClass) ? "110px" : "70px" : "0px" }}>
        {!isMobile && <Breadcrumbs isAds={true} />}
        <div className={s.containerBox}>
          <div className={s.mainBox}>
            <div className={s.flex}>
              <div className={s.left}>
                <TeacherInfos postsCount={postsCount} docsCount={docsCount} />
              </div>
              <div className={s.main}>
                <MainContent onAddPost={handleAddPost} handleAddDocs={handleAddDocs} />
              </div>
              <div className={s.right}>
                <TeacherEvents />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TeacherActivities;
